<script lang="ts" setup>
    defineProps<{
        block: LogosBlock
    }>()
</script>

<template>
    <div class="layout-grid block-gap-y overflow-hidden">
        <h2 class="col-span-full col-start-3 text-3xl uppercase" v-if="block.title">
            {{ block.title }}
        </h2>

        <div
            class="logo-items col-span-full col-start-1 my-48 flex gap-x-2.5"
            data-aos="fade-up"
            :data-aos-delay="i * 100"
        >
            <BlockLogo v-for="(logo, i) in block.logos" :block="logo" />
        </div>
    </div>
</template>
